import PropTypes from 'prop-types';
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';

import MessageCenterFooter from '../../components/MessageCenterFooter/MessageCenterFooter';
import PriorMessage from '../../components/PriorMessage/PriorMessage';
import ButtonWithLoadingIndicator from '../../shared/ButtonWithLoadingIndicator/ButtonWithLoadingIndicator';
import SecondaryButton from '../../shared/SecondaryButton/SecondaryButton';
import { callApi, REPLY, SUCCESS } from '../../utils/api';
import { appendIdToBody, replaceBreaksWithBr } from '../../utils/utils';
import WebViewContext from '../../utils/webview-context';
import styles from './Reply.module.scss';

const Reply = ({
  accountTypes,
  additionalState: { selectedMessage = {} } = {},
  apiKey,
  baseUrl,
  customerType,
  messageFromId,
  openModal,
  transition
}) => {
  const isCustomerWebView = useContext(WebViewContext) || false;
  const [message, setMessage] = useState('');
  const textAreaEl = useRef(null); // textarea's height does not expand to fit it's content, this is to update the height instead of scrolling

  useEffect(() => {
    if (textAreaEl.current) {
      textAreaEl.current.style.height = 0; // Fix for constantly growing box https://stackoverflow.com/questions/10722058/height-of-textarea-increases-when-value-increased-but-does-not-reduce-when-value
      textAreaEl.current.style.height = textAreaEl.current.scrollHeight + 'px'; // Solution from: https://stackoverflow.com/questions/2803880/is-there-a-way-to-get-a-textarea-to-stretch-to-fit-its-content-without-using-php
    }
  }, [message]);

  const addREFcode = message => {
    const finalMessage = appendIdToBody(message, customerType, accountTypes);
    const parsedMessage = replaceBreaksWithBr(finalMessage);
    return parsedMessage;
  };

  const { fromId, messageId, subject } = selectedMessage;
  return (
    <Fragment>
      <div className={styles['reply-container']}>
        <h2 className={`${styles.header} branded-header`} id="reply-title">
          Reply
        </h2>
        <div className={`blocked_data ${styles['reply-main']}`}>
          <p className={`${styles['mobile-header']} branded-header`}>Reply</p>
          <p
            className={`${styles['message-subject']} branded-header`}
            dangerouslySetInnerHTML={{
              __html: `Re: ${selectedMessage.subject}`
            }}
          ></p>
          <textarea
            className={`blocked_data ${styles['message-content']}`}
            onChange={e => setMessage(e.target.value)}
            placeholder="To reply to this secure email, type your message here."
            ref={textAreaEl}
            value={message}
          />
          <PriorMessage {...selectedMessage} isReply />
          <div className={styles['message-buttons']}>
            <SecondaryButton
              className={styles['cancel-button']}
              id="cancel-message"
              onClick={() => transition('back')}
            >
              Cancel
            </SecondaryButton>
            <ButtonWithLoadingIndicator
              className={`${styles['send-button']} branded-button`}
              disabled={!message || isCustomerWebView}
              id="send-message"
              onClick={async () => {
                const res = await callApi(baseUrl, apiKey, REPLY, {
                  content: addREFcode(replaceBreaksWithBr(message)),
                  fromId: messageFromId,
                  replyId: messageId,
                  subject: `Re: ${subject}`,
                  toId: fromId
                });
                res.status !== SUCCESS
                  ? openModal({ type: 'sendError' })
                  : openModal({ type: 'send' });
              }}
            >
              Send
            </ButtonWithLoadingIndicator>
          </div>
        </div>
        <MessageCenterFooter
          leftText={
            <span>
              Please be advised that financial transactions cannot be handled by
              email.
            </span>
          }
        />
      </div>
    </Fragment>
  );
};

Reply.propTypes = {
  accountTypes: PropTypes.arrayOf(PropTypes.number),
  additionalState: PropTypes.shape({
    selectedMessage: PropTypes.object
  }),
  apiKey: PropTypes.string,
  baseUrl: PropTypes.string,
  customerType: PropTypes.number,
  messageFromId: PropTypes.string,
  openModal: PropTypes.func,
  transition: PropTypes.func,
  webViewEnabled: PropTypes.bool
};

export default Reply;
